import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

import { BillingDetailsFormComponent, VatChanges } from '../../forms/billing-details/billing-details-form.component';
import { OrderSummaryComponent } from '../../order-summary/order-summary.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'billing-and-summary',
  imports: [BillingDetailsFormComponent, OrderSummaryComponent],
  templateUrl: './billing-and-summary.component.html',
})
export class BillingAndSummaryComponent {
  @Input()
  currentStepIndex: number;
  @Input()
  yearlyBillingToggle: FormControl<boolean>;
  @Output()
  billingSaved = new EventEmitter<void>();
  @ViewChild(BillingDetailsFormComponent)
  billingDetailsForm: BillingDetailsFormComponent;
  @Output()
  estimatesDone = new EventEmitter<boolean>();

  vatInfo: VatChanges;
  vatNumber: string;
  countryCode: string;

  vatChanged(changes: VatChanges) {
    this.vatInfo = changes;
  }

  countryChanged(countryCode: string) {
    this.countryCode = countryCode;
  }
}
